import React, { useState, useEffect, useCallback } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { DropzoneDialog } from "material-ui-dropzone";
import * as XLSX from "xlsx";
//Material
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
//Component
import FormInput from "../../../stories/hook-controls/input";
import { Modal } from "../../../stories/modal";
import ComoValidateType from "../../../stories/selection-control/combo/validate-type";
import ComoVerticaConfig from "../../../stories/selection-control/combo/vertica-config";
//Function
import * as common from "../../../utils/common-function";
import * as alertDialog from "../../../utils/alert";
import * as api from "../api";
import { GetValidateType } from "../../../module/master/api";
import { GetUser } from "../../../utils/sessions";
import ValidateTypeConst from "../../../const/validate_type";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 1200,
  },
  labelTitle: {
    marginTop: theme.spacing(0),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    minWidth: 150,
  },
  inputHeader: { maxWidth: 600 },
  inputBrowse: { maxWidth: 530 },
  textLabel: {
    color: "#000",
    whiteSpace: "nowrap",
  },
  validateTypeCell: {
    maxWidth: 80,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  conditionTextInput: {
    minWidth: 350,
  },
}));

function MasterTemplateImportModal(props) {
  const classes = useStyles();

  const { open, onClose, editmode, viewmode } = props;
  const { data, fetchmain = () => {}, ...otherprops } = props;

  const [loading, setLoading] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [file, setfile] = useState([]);
  const [columnDataList, setColumnDataList] = useState([]);
  const [validateTypeList, setValidateTypeList] = useState([]);

  const ingoreList = [
    ValidateTypeConst.NO_VALIDATE,
    ValidateTypeConst.NOT_NULL,
    ValidateTypeConst.IS_NUMBER,
  ];

  const method = useForm();
  const { setValue, getValues, setError, clearErrors, errors } = method;

  const fetch = useCallback(
    async (templateId, version) => {
      const param = {
        TEMPLATE_ID: templateId,
        VERSION: version,
        USER_ID: GetUser(),
        MODE: "Refresh",
      };
      const res = await api.GetConfigMasterTemplate(param);
      setColumnDataList(res?.COLUMN_LIST ?? []);

      // Bind data
      let result = common.setDataToFormHookV2(res);
      setTimeout(() =>
        result?.forEach(({ name, value }) => {
          if (Array.isArray(value)) {
            value.forEach((item, itemIndex) => {
              if (Array.isArray(item.CONDITION_LIST)) {
                item.CONDITION_LIST.forEach((condition) => {
                  let res = common.setDataToFormHookV2(condition);
                  res?.forEach(({ name, value }) => {
                    setValue(`${name}_${itemIndex}_${condition.SEQ}`, value);
                  });
                });
              }
            });
          } else {
            setValue(name, value);
          }
        })
      );
    },
    [setValue]
  );

  const fetchValidateType = useCallback(async () => {
    const res = await GetValidateType();
    setValidateTypeList(res);
  }, [setValidateTypeList]);

  useEffect(() => {
    if (!open) return;
    fetchValidateType();
    if (typeof data === "undefined") return;
    // clear
    setColumnDataList([]);
    setfile([]);
    //fetchValidateType();
    if (data) {
      fetch(data.TEMPLATE_ID, data.VERSION);
    }
  }, [fetchValidateType, fetch, data, setValue, open]);

  useEffect(() => {
    columnDataList.forEach((column, rowIndex) => {
      column.CONDITION_LIST.forEach((condition, index) => {
        setValue(
          `CONDITION_TEXT_${rowIndex}_${index + 1}`,
          condition.CONDITION_TEXT || ""
        );
        setValue(
          `VALIDATE_TYPE_${rowIndex}_${index + 1}`,
          condition.VALIDATE_TYPE
        );
      });
    });
  }, [columnDataList, setValue]);

  async function upload(files = []) {
    setColumnDataList([]);
    setfile(files[0]);
    setValue("PATH_FILE_OLD", files[0].name);
    handleFileUpload(files[0]);
  }

  const handleFileUpload = (newFile) => {
    if (!newFile) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      const bstr = new Uint8Array(evt.target.result);
      const wb = XLSX.read(bstr, { type: "array" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      const dataStringLines = data.split(/\r\n|\n/);
      const headers = dataStringLines[0].split(
        /[,|](?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
      );

      const listColumn = headers.map((header, index) => ({
        COLUMN_SEQ: index + 1,
        COLUMN_NAME: header,
        CONDITION_LIST: [
          {
            VALIDATE_TYPE: ValidateTypeConst.NO_VALIDATE, // default no validate
            VALIDATE_TYPE_HINT: null,
            CONDITION_TEXT: null,
            SEQ: 1,
          },
        ],
      }));
      setColumnDataList(listColumn);
    };

    reader.readAsArrayBuffer(newFile);
  };

  const onFileChange = async (event) => {
    const fileData = event.target.files[0];
    if (fileData === undefined) return;
    if (fileData?.size > 2097152) {
      //2,097,152 bytes
      alertDialog.ErrorDialog("File size cannot exceed more than 2MB");
      setfile([]);
      return;
    }
  };

  const onAddCondition = (rowIndex) => {
    setColumnDataList((prevData) => {
      const newData = [...prevData];
      const targetRow = newData[rowIndex];
      const maxSeqInGroup = targetRow.CONDITION_LIST.reduce(
        (maxSeq, condition) => Math.max(maxSeq, condition.SEQ),
        0
      );

      const newCondition = {
        VALIDATE_TYPE: ValidateTypeConst.NO_VALIDATE, // default no validate
        VALIDATE_TYPE_HINT: null,
        CONDITION_TEXT: null,
        SEQ: maxSeqInGroup + 1,
      };
      targetRow.CONDITION_LIST.push(newCondition);
      return newData;
    });
  };

  const onDeleteCondition = async (rowIndex, conditionIndex) => {
    let res = await alertDialog.ConfirmDelete();
    if (!res) return;
    setColumnDataList((prevData) => {
      const newData = [...prevData];
      const targetRow = newData[rowIndex];
      const conditions = targetRow.CONDITION_LIST;

      const updatedConditions = conditions
        .filter((_, index) => index !== conditionIndex)
        .map((condition, index) => ({
          ...condition,
          SEQ: index + 1,
        }));

      targetRow.CONDITION_LIST = updatedConditions;
      newData[rowIndex] = targetRow;
      return newData;
    });
  };

  const handleValidateTypeChange = (event, rowIndex, conditionIndex, seq) => {
    const newValue = event.target.value;
    var isClearCondition = ingoreList.includes(newValue);

    setColumnDataList((prevColumnDataList) => {
      return prevColumnDataList.map((row, i) => {
        if (i === rowIndex) {
          return {
            ...row,
            CONDITION_LIST: row.CONDITION_LIST.map((condition, index) => {
              if (conditionIndex === index) {
                return {
                  ...condition,
                  CONDITION_TEXT: isClearCondition
                    ? null
                    : condition.CONDITION_TEXT,
                  VALIDATE_TYPE: newValue,
                  VALIDATE_TYPE_HINT:
                    validateTypeList.find(
                      (type) => type.VALIDATE_TYPE === parseInt(newValue)
                    )?.VALIDATE_TYPE_HINT || null,
                };
              }
              return condition;
            }),
          };
        }
        return row;
      });
    });
    // Clear condition text
    if (isClearCondition) {
      setValue(`CONDITION_TEXT_${rowIndex}_${seq}`, "");
    }
  };

  const handleConditionBlur = (event, rowIndex, conditionIndex) => {
    const newValue = event.target.value;
    setColumnDataList((prevColumnDataList) => {
      return prevColumnDataList.map((row, i) => {
        if (i === rowIndex) {
          return {
            ...row,
            CONDITION_LIST: row.CONDITION_LIST.map((condition, index) => {
              if (conditionIndex === index) {
                return {
                  ...condition,
                  CONDITION_TEXT: newValue,
                };
              }
              return condition;
            }),
          };
        }
        return row;
      });
    });
  };

  const validateConditions = () => {
    let validationMessages = [];

    columnDataList.forEach((row) => {
      row.CONDITION_LIST.forEach((condition) => {
        if (!condition.VALIDATE_TYPE) {
          validationMessages.push(
            `${row.COLUMN_NAME} - Row ${condition.SEQ} : Please Select Validate Type.`
          );
        } else if (
          !ingoreList.includes(condition.VALIDATE_TYPE) &&
          common.isEmptyStr(condition.CONDITION_TEXT?.trim())
        ) {
          validationMessages.push(
            `${row.COLUMN_NAME} - Row ${condition.SEQ} : Please Input Condition.`
          );
        } else if (
          !ingoreList.includes(condition.VALIDATE_TYPE) &&
          condition.CONDITION_TEXT?.length > 1000
        ) {
          console.log(condition.CONDITION_TEXT?.length);
          validationMessages.push(
            `${row.COLUMN_NAME} - Row ${condition.SEQ} : Condition text length must be 1000 characters or less.`
          );
        }
      });
    });

    return validationMessages;
  };

  const onUploadTemplate = async () => {
    //console.log(columnDataList);

    clearErrors("HOST_KEY");
    clearErrors("TEMPLATE_NAME");
    clearErrors("TARGET_TABLE");

    const TEMPLATE_ID = data?.TEMPLATE_ID;
    const TEMPLATE_NAME = getValues().TEMPLATE_NAME;
    const TARGET_TABLE = getValues().TARGET_TABLE;
    const HOST_KEY = getValues().HOST_KEY;
    const PATH_FILE_OLD = getValues().PATH_FILE_OLD;

    if (common.isEmptyStr(HOST_KEY.trim())) {
      setError("HOST_KEY", {
        type: "manual",
        message: "Please select server vertica.",
      });
      return;
    }

    if (common.isEmptyStr(TEMPLATE_NAME.trim())) {
      setError("TEMPLATE_NAME", {
        type: "manual",
        message: "The Tempalte name field is required",
      });
      return;
    }
    if (common.isEmptyStr(TARGET_TABLE.trim())) {
      setError("TARGET_TABLE", {
        type: "manual",
        message: "The Target table field is required",
      });
      return;
    }
    if (common.isEmptyStr(PATH_FILE_OLD.trim())) {
      alertDialog.ErrorDialog("Please upload file.");
      return;
    }

    const errors = validateConditions();
    if (errors.length > 0) {
      alertDialog.ErrorListDialog("Error in Data Validation", errors);
      return;
    }

    let form = new FormData();
    let info = {};
    info.COLUMN_LIST = columnDataList;
    info.TEMPLATE_ID = TEMPLATE_ID;
    info.TEMPLATE_NAME = TEMPLATE_NAME;
    info.TARGET_TABLE = TARGET_TABLE;
    info.HOST_KEY = HOST_KEY;
    info.USER_ID = GetUser();

    if (common.isEmptyArray(file)) {
      info.FILE_NAME = data?.FILE_NAME;
      info.PATH_FILE = data?.PATH_FILE;
      info.PATH_FILE_OLD = data?.PATH_FILE_OLD;
    }

    form.append("file", file);
    form.append("info", JSON.stringify(info));

    if (!loading) {
      setLoading(true);
    }

    let res = await api.UploadTemplate(form);
    setLoading(false);
    if (res?.ResultCode === 10) {
      fetchmain();
      onClose();
      alertDialog.inform_success();
    } else {
      alertDialog.ErrorDialogSQL(res?.Message);
    }
  };

  return (
    <Modal
      {...otherprops}
      onSave={onUploadTemplate}
      hiddenSave={viewmode === 1}
      maxWidth="xl"
      title={"Config master template"}
    >
      <FormProvider {...method}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <FormControl variant="outlined" className={classes.labelTitle}>
              <InputLabel className={classes.textLabel}>
                Server Vertica :{" "}
              </InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={10}>
            <ComoVerticaConfig
              className={classes.inputHeader}
              id={`HOST_KEY`}
              fullWidth
              name={`HOST_KEY`}
              errorobj={errors}
              module={`UPLOAD_DATA`}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <FormControl variant="outlined" className={classes.labelTitle}>
              <InputLabel className={classes.textLabel}>
                Template Name :{" "}
              </InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={10}>
            <FormInput
              id="outlined-full-width"
              className={classes.inputHeader}
              disabled={viewmode === 1 || editmode === 1}
              fullWidth
              name="TEMPLATE_NAME"
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              autoComplete="off"
              errorobj={errors}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <FormControl variant="outlined" className={classes.labelTitle}>
              <InputLabel className={classes.textLabel}>
                Target table :{" "}
              </InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={10}>
            <FormInput
              id="outlined-full-width"
              className={classes.inputHeader}
              disabled={viewmode === 1}
              fullWidth
              name="TARGET_TABLE"
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              autoComplete="off"
              errorobj={errors}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <FormControl variant="outlined" className={classes.labelTitle}>
              <InputLabel className={classes.textLabel}>
                Upload File :{" "}
              </InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={10} className={classes.textXS12}>
            <FormControl variant="outlined" fullWidth={true}>
              <Box display="flex" className="browseFile">
                <FormInput
                  disabled
                  id="outlined-full-width"
                  className={classes.inputBrowse}
                  label=""
                  fullWidth
                  name="PATH_FILE_OLD"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                />
                <button
                  disabled={viewmode === 1}
                  onClick={() => {
                    setOpenUpload(true);
                  }}
                >
                  Browse
                </button>
                <input
                  type="file"
                  name="file"
                  onChange={onFileChange}
                  accept=".csv"
                  style={{ display: "none" }}
                />
              </Box>
            </FormControl>
            <DropzoneDialog
              acceptedFiles={[
                ".csv, text/csv, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values",
              ]}
              cancelButtonText={"cancel"}
              filesLimit={1}
              submitButtonText={"submit"}
              maxFileSize={52428800}
              open={openUpload}
              onClose={() => setOpenUpload(false)}
              onSave={(files) => {
                upload(files);
                setOpenUpload(false);
              }}
              showPreviews={true}
              showFileNamesInPreview={true}
            />
          </Grid>
          {/* Table */}
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="condition table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">No.</TableCell>
                  <TableCell align="center">Column</TableCell>
                  <TableCell></TableCell>
                  <TableCell align="center">Validate Type</TableCell>
                  <TableCell align="center">Condition</TableCell>
                  <TableCell align="center"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {columnDataList.length > 0 ? (
                  columnDataList.map((row, rowIndex) =>
                    row.CONDITION_LIST.map((condition, conditionIndex) => (
                      <TableRow key={`row-${rowIndex}-${conditionIndex}`}>
                        {conditionIndex === 0 && (
                          <>
                            <TableCell
                              align="center"
                              rowSpan={row.CONDITION_LIST.length}
                            >
                              {rowIndex + 1}
                            </TableCell>
                            <TableCell
                              align="center"
                              rowSpan={row.CONDITION_LIST.length}
                            >
                              {row.COLUMN_NAME}
                            </TableCell>
                          </>
                        )}
                        <TableCell align="right">{condition.SEQ}</TableCell>
                        <TableCell className={classes.validateTypeCell}>
                          <ComoValidateType
                            id={`validate-type-${rowIndex}-${condition.SEQ}`}
                            fullWidth
                            name={`VALIDATE_TYPE_${rowIndex}_${condition.SEQ}`}
                            errorobj={errors}
                            onChange={(e) =>
                              handleValidateTypeChange(
                                e,
                                rowIndex,
                                conditionIndex,
                                condition.SEQ
                              )
                            }
                            disabled={viewmode === 1}
                          />
                        </TableCell>
                        <TableCell>
                          {
                            <FormInput
                              id={`condition-text-${rowIndex}-${condition.SEQ}`}
                              className={classes.conditionTextInput}
                              fullWidth
                              name={`CONDITION_TEXT_${rowIndex}_${condition.SEQ}`}
                              placeholder={condition.VALIDATE_TYPE_HINT}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              variant={
                                viewmode === 1 ||
                                ingoreList.includes(condition.VALIDATE_TYPE)
                                  ? "filled"
                                  : "outlined"
                              }
                              autoComplete="off"
                              onBlur={(e) =>
                                handleConditionBlur(e, rowIndex, conditionIndex)
                              }
                              errorobj={errors}
                              disabled={
                                viewmode === 1 ||
                                ingoreList.includes(condition.VALIDATE_TYPE)
                              }
                            />
                          }
                        </TableCell>
                        <TableCell>
                          {viewmode !== 1 && conditionIndex === 0 && (
                            <Tooltip
                              title="Add Condition"
                              placement="right-start"
                            >
                              <Fab
                                style={{ left: "1rem" }}
                                size="small"
                                color="primary"
                                aria-label="Upload File"
                                onClick={() => onAddCondition(rowIndex)}
                              >
                                <AddIcon />
                              </Fab>
                            </Tooltip>
                          )}
                          {viewmode !== 1 && conditionIndex > 0 && (
                            <Tooltip
                              title="Delete Condition"
                              placement="right-start"
                            >
                              <Fab
                                style={{ left: "1rem" }}
                                size="small"
                                color="secondary"
                                aria-label="Upload File"
                                onClick={() =>
                                  onDeleteCondition(rowIndex, conditionIndex)
                                }
                              >
                                <DeleteIcon />
                              </Fab>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={5}>
                      No conditions
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid item xs={12}>
            {loading && <LinearProgress />}
            {loading && <LinearProgress color="secondary" />}
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  );
}
export default MasterTemplateImportModal;
